import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";
import "firebase/storage";

var config = {
    apiKey: "AIzaSyDg387ctjssxidzYpOlBFovVyW8cemATcg",
    authDomain: "zametix-9a1ec.firebaseapp.com",
    databaseURL: "https://zametix-9a1ec.firebaseio.com",
    projectId: "zametix-9a1ec",
    storageBucket: "zametix-9a1ec.appspot.com",
    messagingSenderId: "458579689701"
};
firebase.initializeApp(config);


export default firebase;



// WEBPACK FOOTER //
// ./src/actions/firebase.js